<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div class="button-map-wrap">
      <table class="button-map" style="border-collapse: separate; border-spacing: 5px">
        <tbody>
          <tr v-for="row in rows" :style="rowStyle">
            <td v-for="col in row.filter(c => c.exists)" :colspan="col.colspan" :rowspan="col.rowspan" :class="col.className" :style="cellStyle + ' width: ' + (100/columnCount) * col.colspan + '%'" @click="addToBasketClicked(col)">
              <span class="mapitem-content" v-if="!col.empty">
                <span class="mapitem-title">{{ col.t }}</span>
                <span class="mapitem-price">{{ $filters.currency(col.p, 'EUR') }}</span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <button v-on:click="logout" v-if="false">Logout</button>
    </div>
    <LazyReservableProductListItem v-if="productToAdd" :column="column" :activeComponent="component" :baseDomain="baseDomain" :key="productToAdd.key" :product="productToAdd.product" :productShopId="productToAdd.shopId" :auto="true" :allowResourceSelection="true" v-on:productModalClosed="productModalClosed">
      {{ productToAdd.product.name }}
    </LazyReservableProductListItem>
  </div>
</template>
<script>

import axios from 'axios'
import components from '~/lib/components'
import { productNeedsModal } from '~/lib/products'

export default {
  mixins: [components],
  data () {
    return {
      modalQueue: [],
      modalSeq: 0
    }
  },
  computed: {
    productToAdd () {
      return this.modalQueue.length ? this.modalQueue[0] : null
    },
    data: {
      get() {
        return JSON.parse(this.component.data)
      },
      set(newValue) {
        this.component.data = newValue
        // Vue.set(this.component, 'data', newValue)
      }
    },
    columnCount () {
      if (!(this.data && this.data.dimensions && this.data.dimensions.cols)) {
        return 1
      }
      return parseInt(this.data.dimensions.cols,10)
    },
    rowCount () {
      if (!(this.data && this.data.dimensions && this.data.dimensions.rows)) {
        return 1
      }
      return parseInt(this.data.dimensions.rows,10)
    },
    cellStyle () {
      return 'min-width: '+ (100 / this.columnCount) + '%;'
    },
    rowStyle () {
      return 'height: '+ (100 / this.rowCount) + '%;'
    },
    rows () {
      let ret = []
      if (!(this.data && this.data.dimensions)) {
        return ret
      }
      let d = this.data.dimensions
      let e = this.data.elements
      let cols = d.cols
      let rows = d.rows
      for (var i = 0; i < rows; i++) {
        if (!ret[i]) {
          ret[i] = []
        }
        for (var j = 0; j < cols; j++) {
          ret[i][j] = { id: null, t: '', p: '', colspan: 1, rowspan: 1, empty: true, exists: true, className: '', prod: [] }
        }
      }
      for (i = 0; i < e.length; i++) {
        let b = e[i]
        let y = parseInt(b.y, 10)
        let x = parseInt(b.x, 10)
        let w = parseInt(b.w, 10)
        let h = parseInt(b.h, 10)
        ret[y][x] = { id: b.id, t: b.t, p: b.p, colspan: w, rowspan: h, empty: false, exists: true, className: 'mapitem mapitem-color-' + b.c, prod: b.prod }
        for (var xOff = 0; xOff < w; xOff++) {
          for (var yOff = 0; yOff < h; yOff++) {
            if (xOff > 0 || yOff > 0) {
              ret[y + yOff][x + xOff].exists = false
            }
          }
        }
      }
      return ret
    }
  },
  methods: {
    async loadProduct (shopId, id) {
      let response = await axios.get(this.baseDomain + shopId + '/products/' + id + '.json?version=' + this.version)
      .catch(function (e) {
      })
      return response ? response.data : false
    },
    async reloadComponentData () {
      if (!this.component && this.component.id) {
        return false
      }
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/components/' + this.component.id + '.json?files=true&apikey=' + this.apiKey + this.versionStr)
      } catch (e) {
        this.showError(e)
        return false
      }
      if(!response.data && response.data.data) {
        return false
      }
      return response.data.data
    },
    async addToBasketClicked (col) {
      let loadProducts = {}
      for (var i = 0; i < col.prod.length; i++) {
        if (!loadProducts[col.prod[i]]) {
          loadProducts[col.prod[i]] = 0
        }
        loadProducts[col.prod[i]]++
      }
      let actualTotal = 0
      for (var prod in loadProducts) {
        if (Object.prototype.hasOwnProperty.call(loadProducts, prod)) {
          let count = loadProducts[prod]
          let prodArr = prod.split('-')
          let shopId = prodArr[0]
          let productId = prodArr[1]
          let product = await this.loadProduct(shopId, productId)
          if (product) {
            // Variations etc. are chosen in the product modal, one product at a time
            if (productNeedsModal(product)) {
              this.modalQueue.push({ product: product, shopId: shopId, key: ++this.modalSeq })
            } else {
              this.addProductToBasket(product, shopId, count)
            }
            actualTotal += product.price * count
          }
        }
      }
      // In case the button's associated products' prices have changed, update them to the button
      if (actualTotal !== parseFloat(col.p)) {
        this.updateActualPrice(col, actualTotal)
        col.p = actualTotal
      }
    },
    productModalClosed () {
      this.modalQueue.shift()
    },
    addProductToBasket (product, shopId, count) {
      let $this = this
      let data = {
        version: this.version,
        locale: this.locale,
        product: product,
        shopId: shopId,
        count: count
      }
      this.$store.dispatch('addToBasket', data)
      .then(function () {
        $this.showAddedToBasketNotification($this.$filters.marketingname(product))
      })
      .catch(function (err) {
        $this.showAddedToBasketError(err)
      })
    },
    async logout () {
      try {
        await this.$store.dispatch('logout')
      } catch (e) {
      }
    },
    getSaveData () {
      const exportFields = [
        'id',
        'name',
        'type',
        'data'
      ]
      const data = exportFields.reduce((a, e) => (a[e] = this.component[e], a), {})
      return data
    },
    async updateActualPrice(col, actualTotal) {
      let el = this.data.elements.find(e => e.id === col.id)
      if (!el) {
        return
      }

      const currentButtonData = await this.reloadComponentData()
      if (currentButtonData) {
        this.data = currentButtonData
      }
      el.p = actualTotal
      this.component.data = JSON.stringify(this.data)
      const data = this.getSaveData()

      if (!data.id) {
        return
      }
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/components/' + data.id + '.json?apikey=' + this.apiKey, data)
      } catch(e) {}

    }
  }
}

</script>

<style scoped>
.button-map td {
  width: 115px; height: 50px;
}
.button-map td.mapitem:hover {
  cursor: pointer;
}
</style>